<template>
  <div class="index_role_and_prize">
    <wd-img class="png_role" :src="roleBtn" @click="toRole"/>
    <wd-img class="png_prize" :src="prizeBtn" @click="toPrize"/>
  </div>
</template>

<script>
import {prizeBtn,roleBtn} from "@/skin/skin";

export default {
  name: "RightAction",
  data(){
    return{
      prizeBtn:prizeBtn,
      roleBtn:roleBtn,
    }
  },
  methods:{
    toRole(){
      this.$router.push("/role")
    },
    toPrize(){
      this.$router.push("/prize")
    },
  }
}
</script>

<style lang="scss">
.index_role_and_prize {
  position: absolute;
  right: 0;
  top: 212px;
  width: 40px;
  display: flex;
  flex-direction: column;

  .png_role {
    position: relative;
    margin-bottom: 8px;
  }

  .png_prize {
    position: relative;
  }
}

</style>
